<template>
  <div class="card">
    <h2 class="card__title">
      輸入捐款人資訊
    </h2>
    <hr>
    <FormRow>
      <div :class="$style.formControl">
        <FormLabel>
          捐款人姓氏
        </FormLabel>
        <TextInput
          id="lastName"
          :value.sync="form.lastName"
          autocomplete="family-name"
          placeholder="請輸入捐款人姓氏"
        />
      </div>

      <div :class="$style.formControl">
        <FormLabel>
          捐款人名字
        </FormLabel>
        <TextInput
          id="firstName"
          :value.sync="form.firstName"
          autocomplete="given-name"
          placeholder="請輸入捐款人名字"
        />
      </div>
    </FormRow>

    <FormRow>
      <div :class="$style.formControl">
        <FormLabel>
          捐款人手機號碼
        </FormLabel>
        <TextInput
          id="tel"
          :value.sync="form.tel"
          inputmode="tel"
          autocomplete="tel"
          placeholder="請輸入捐款人手機號碼"
          :error="phoneNumberError"
        />
        <Button
          small
          :disabled="!isAllowSendVerificationCode"
          @click.native="sendVerificationCode"
        >
          <LoadingDots
            v-if="isFetching"
            :theme="`white`"
          />
          <template v-else>
            傳送驗證碼
            <span v-if="countdownSeconds > 0">
              ({{ countdownSeconds }}s)
            </span>
          </template>
        </Button>
      </div>
    </FormRow>

    <FormRow center>
      <div :class="[$style.formControl]">
        <FormLabel>
          驗證碼
        </FormLabel>
        <TextInput
          id="verificationCode"
          :value.sync="form.verificationCode"
          autocomplete="one-time-code"
          placeholder="請輸入驗證碼"
        />
      </div>
    </FormRow>

    <Align center>
      <RouterLink to="/search">
        <Button transparent>
          上一步
        </Button>
      </RouterLink>

      <Button @click.native="search">
        查詢
      </Button>
    </Align>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import timerWorker from '@/workers/timer';
// stores
import memberState from '@/store/modules/member';
// components
import Align from '@/components/layout/Align';
import FormRow from '@/components/form/FormRow.vue';
import FormLabel from '@/components/form/FormLabel.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import Button from '@/components/buttons/Button.vue';
import LoadingDots from '@/components/animations/LoadingDots.vue';
import {
  isValidString,
} from '../../utilities/validators';

const RESEND_TIME = 60000; // 60 sec

export default {
  components: {
    Align,
    Button,
    FormRow,
    FormLabel,
    TextInput,
    LoadingDots,
  },
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        tel: '',
        verificationCode: '',
      },
      countdownSeconds: 0,
      phoneNumberError: '',
    };
  },
  computed: {
    isAllowSendVerificationCode() {
      return this.countdownSeconds === 0 && !this.isFetching;
    },
    ...mapState('member', {
      isFetching: state => state.fetching,
    }),

    isValid() {
      return !this.phoneNumberError;
    },
  },
  beforeCreate() {
    if(this.$store.state.member) {
      return;
    }
    this.$store.registerModule('member', memberState);
  },
  beforeDestroy() {
    this.worker = null;
  },
  methods: {

    checkForErrors() {
      if(!isValidString(this.form.tel)) {
        this.phoneNumberError = '以非全形(小寫)數字填寫';
      } else {
        this.phoneNumberError = '';
      }
    },

    async sendVerificationCode() {
      if(!this.isAllowSendVerificationCode) return;

      const result = await this.phoneSMSVerificationSend({
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        tel: this.form.tel,
      });

      if(!result) return false;

      // 設定計時器，避免 DoS
      timerWorker.send({
        time: RESEND_TIME,
      });

      timerWorker.worker.onmessage = event => {
        const message = event.data;
        this.countdownSeconds = Math.floor(message.time / 1000);
      };

      return true;
    },
    async search() {
      this.checkForErrors();
      if(!this.isValid) return;
      const result = await this.phoneSMSVerify({
        verificationCode: this.form.verificationCode,
      });
      if(!result) return;

      this.$router.push({
        name: 'SearchResult',
      });
    },
    ...mapActions('member', [
      'phoneSMSVerificationSend',
      'phoneSMSVerify',
    ]),
  },
};
</script>

<style lang="scss" module>
  .formControl {
    margin-bottom: 1rem;
  }
</style>
